import React from 'react'
import TimeSeries from './components/TimeSeries';
import ZonalStatisticsToolWindow from './components/ZonalStatisticsToolWindow';

const HomeOverlay = ({
  mapRef, ZSTPopUpContent, setMapParameters, setZSTPopUpContent, startDate, fetchCommonDates, setStartDate, setEnabledDates, tscCoords, tscModeRef, isButtonClicked, setIsButtonClicked, layerRefs, setIsDatePickerDisabled, isDatePickerDisabled
}) => {
  return (
    <>

      {
        ZSTPopUpContent && (
          <ZonalStatisticsToolWindow
            ZSTPopUpContent={ZSTPopUpContent}
            setZSTPopUpContent={setZSTPopUpContent}
            startDate={startDate}
          />
        )
      }

      <TimeSeries
        mapRef={mapRef}
        setMapParameters={setMapParameters}
        layerRefs={layerRefs}
        setEnabledDates={setEnabledDates}
        isDatePickerDisabled={isDatePickerDisabled}
        setIsDatePickerDisabled={setIsDatePickerDisabled}
        tscCoords={tscCoords}
        tscModeRef={tscModeRef}
        fetchCommonDates={fetchCommonDates}
        isButtonClicked={isButtonClicked}
        setIsButtonClicked={setIsButtonClicked}
        setStartDate={setStartDate}
      />
    </>
  )
}

export default HomeOverlay;